/**
 * react-admin calls authProvider.logout() when checkAuth rejects with redirectTo.
 * MFA redirects must keep the Supabase session alive, so we skip real logout once.
 */
let pendingMfaRedirect: string | null = null;

export function markPendingMfaRedirect(redirectTo: string) {
  pendingMfaRedirect = redirectTo;
}

export function consumePendingMfaRedirect(): string | null {
  const redirectTo = pendingMfaRedirect;
  pendingMfaRedirect = null;
  return redirectTo;
}
